import { render, staticRenderFns } from "./users_dashboard.vue?vue&type=template&id=6bd2556f&scoped=true&"
import script from "./users_dashboard.vue?vue&type=script&lang=js&"
export * from "./users_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd2556f",
  null
  
)

export default component.exports